import { Links } from "./vehicleSearch.type";

const getPageLinkAndRel = (type: string, links: Links[]):Links => {
  const pageType = links.filter((current) => current?.rel === type);
  return {
    href: pageType[0]?.href,rel: pageType[0]?.rel 
  };
};

export default getPageLinkAndRel;

